import { Navbar, NavItem } from 'react-bootstrap';

interface IProps {
    firstName: string,
    lastName: string,
    pathname: string,
    currentUrl: string
}

const OpsMenus: React.FC<IProps> = (props) => {
    return (
        <div className='nkr-menu'>
            <div className='navbar navbar-inverse'>
                <div className='navbar-collapse collapse'>
                    <ul className='nav navbar-nav'>
                        <NavItem active={props.pathname == '/move-tracker'} href={'/move-tracker'}>Move Tracker</NavItem>
                        <NavItem active={props.pathname == '/swap-tracker'} href={'/swap-tracker'}>Swap Tracker</NavItem>
                        <NavItem active={props.pathname == '/beacon-overlay-map'} href={'/beacon-overlay-map'}>Beacon Overlay Map</NavItem>
                        <NavItem active={props.pathname == '/cron-jobs'} href={'/cron-jobs'}>Automated Jobs</NavItem>
                        <NavItem active={props.pathname == '/dash-monitoring'} href={'/cron-jobs'}>DASH Monitoring</NavItem>
                    </ul>

                    <Navbar.Text pullRight style={{ marginTop: 3, marginBottom: 3, paddingTop: 4, paddingBottom: 4, paddingRight: 20 }}>NKR Operations</Navbar.Text>
                </div>
            </div>
        </div>
    );
}

export default OpsMenus;